import Loader from "react-loader-spinner";
import { PencilSquare, PlusSquare, Trash, ExclamationTriangle, DashCircle } from 'react-bootstrap-icons';
import { Table, Modal, Button, Row, Col, Alert } from 'react-bootstrap';
import { getComplaintsTypeList, addEditComplaintsType, deleteComplaintsType } from "../store/api/ComplaintsAPI";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxes, faColumns, faThList, faTimes } from "@fortawesome/free-solid-svg-icons";
const ModalAddEditComplaintType = (props) => {
    const { popData, setPopData } = props;
    const { show } = popData;
    const notForSelect = useRef(false);
    const [currentType, setCurrentType] = useState({ TypeID: 0 });
    const [error, setError] = useState(null);
    const [typeList, setTypeList] = useState(null);

    const close = () => {
        setPopData({
            show: false
        })
        setCurrentType({ TypeID: 0 });
    }
    const addOrUpdateType = () => {
        const onSuccess = (res) => {
            if (res.Error) {
                setError(res.Error);
                return;
            }
            getComplaintsTypeList(setTypeList);
            setCurrentType({ TypeID: 0 });
        }
        if (
            !currentType.TypeName ||
            currentType.TypeName === '') {
            return;
        }

        addEditComplaintsType(currentType, onSuccess);
    }
    const deleteType = (id) => {
        notForSelect.current = true;
        const onDelete = (res) => {
            if (res.Error) {
                setError(res.Error);
            }
            else {
                getComplaintsTypeList(setTypeList);
            }
        }
        deleteComplaintsType(id, onDelete);
    }
    function cancelType() {
        setCurrentType({ TypeID: 0 });
    }
    function rowClick(row) {
        if (notForSelect.current) {
            notForSelect.current = false;
            return;
        }
        setCurrentType(row);
    }
    useEffect(() => {
        if (show)
            getComplaintsTypeList(setTypeList);
    }, [show]);
    return (
        <Modal show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span> <FontAwesomeIcon icon={faThList} size="lg" style={{ marginLeft: "3px" }} /> مدیریت نوع شکایت </span><FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {error && <Alert variant="danger"><ExclamationTriangle size={18} />&nbsp; {error} <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setError(null)} /></Alert>}
                <Table responsive className="fixedTable mt-2" style={{ whiteSpace: "nowrap" }}>
                    <thead>
                        <tr>
                            <th style={{ width: "20%" }}>ترتیب نمایش</th>
                            <th style={{ width: "60%" }}>شرح وضعیت</th>
                            <th style={{ width: "20%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(typeList === "PENDING") &&
                            <tr>
                                <td colSpan={3} style={{ textAlign: "center", width: "100%" }}>
                                    <Loader type="BallTriangle" color="rgb(228, 3, 117)" height={20} width={20} />
                                </td>
                            </tr>
                        }
                        {Array.isArray(typeList?.Data ?? "") &&
                            typeList.Data.map((item, i) =>
                                <tr key={i} className="resultTableRow" onClick={() => rowClick(item)}>
                                    <td style={{ width: "20%" }}>{item.OrderID}</td>
                                    <td style={{ width: "60%" }}>{item.TypeName}</td>
                                    <td style={{ width: "20%" }}>
                                        <Trash className="rowBtn" color="red" size={16} onClick={() => deleteType(item.TypeID)} />
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
                {currentType &&
                    <Row>
                        <Col md={3} style={{ padding: "3px", paddingRight: "10px" }}>
                            <input type="text" className="tableRowInput" value={currentType?.OrderID ?? ""} onChange={e => setCurrentType({ ...currentType, OrderID: e.target.value })} />
                        </Col>
                        <Col md={6} style={{ padding: "3px" }}>
                            <input type="text" className="tableRowInput" value={currentType?.TypeName ?? ""}
                                onChange={e => setCurrentType({ ...currentType, TypeName: e.target.value })} />
                        </Col>
                        <Col md={3} style={{ padding: "2px" }}>
                            <Button variant="info" className="group-Btn-smalll" onClick={addOrUpdateType}>
                                {Number(currentType.TypeID) > 0 && <PencilSquare size={18} />}
                                {Number(currentType.TypeID) === 0 && <PlusSquare size={18} />}
                            </Button>
                            <Button className="group-Btn-smalll" variant="danger"><DashCircle size={18} onClick={cancelType} /></Button>
                        </Col>
                    </Row>
                }
            </Modal.Body>
        </Modal>
    )
}
export default ModalAddEditComplaintType;